import React from "react";
import { Box, Button } from "@mui/material";
import styles from "./style.module.css";
import { FileUploadOutlined } from "@mui/icons-material";
import { useTheme } from "../../../../../../context/themeContext";
import { useDispatch } from "react-redux";
import { updateSkillImageData } from "../../../../../../store/slices/profile/skillImageSlice";

const CoverImageUploader = () => {
  const { theme, darkMode } = useTheme();
  const dispatch = useDispatch();

  return (
    <Box
      className={styles.primarySkills}
      sx={{
        borderColor: theme.palette.lightgrey.lightgrey800,
        background: theme.palette.lightgrey.lightgrey00,
      }}
    >
      <Box className={styles.content}>
        <Button
          variant="text"
          onClick={() =>
            dispatch(updateSkillImageData({ isModalSkillOpen: true }))
          }
          startIcon={<FileUploadOutlined />}
          sx={{
            color: darkMode
              ? theme.palette.darkgrey.darkgrey300
              : theme.palette.darkgrey.darkgrey400,
            textTransform: "capitalize",
          }}
        >
          Upload skill cover image
        </Button>
      </Box>
    </Box>
  );
};
export default CoverImageUploader;
